import React, { createContext, useContext, useState } from "react";

const ParentContext = createContext();

export function ParentProvider({ children }) {
  const storedChildren = JSON.parse(
    localStorage.getItem("parentChildren") || "[]"
  );
  const [childList] = useState(storedChildren);
  const [selectedChild, setSelectedChild] = useState(
    storedChildren[0] || null
  );

  return (
    <ParentContext.Provider value={{ childList, selectedChild, setSelectedChild }}>
      {children}
    </ParentContext.Provider>
  );
}

export const useParent = () => useContext(ParentContext);
